import React, {useEffect} from "react";
import {Container} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";

import {ProductInformation} from "./ProductInfo";
import BreadCrumb from "Common/BreadCrumb";
import {getAttributeList as onGetAttributeList} from "slices/attributes/thunk";
import {getBrandList as onGetBrandList} from "slices/brand/thunk";
import {getCategoryList as onGetCategoryList} from "slices/category/thunk";
import {getColorsList as onGetColorsList} from "slices/color/thunk";
import {getModelList as onGetModelList} from "../../../slices/model/thunk";
import {getDiscountList as onGetDiscountList} from "../../../slices/discount/thunk";
import {getHomeLayout as onGetHomeLayout} from "../../../slices/homeLayout/thunk";
import {getBadge as onGetBadge} from "../../../slices/badge/thunk";

const CreateProduct = () => {
    document.title = "Product create";

    const dispatch = useDispatch<any>();

    const selectBrandList = createSelector(
        (state: any) => state.Brand,
        (brand) => ({
            brandList: brand.brandList
        })
    );
    const selectAttributeList = createSelector(
        (state: any) => state.Attribute,
        (attribute) => ({attributeList: attribute.attributeList})
    );

    const selectCategoryList = createSelector(
        (state: any) => state.Category,
        (category) => ({
            categoryList: category.categoryList
        })
    );
    const selectColorsList = createSelector(
        (state: any) => state.Colors,
        (colors) => ({
            colorsList: colors.colorsList
        })
    );
    const selectModelList = createSelector(
        (state: any) => state.Model,
        (model) => ({
            modelList: model.modelList
        })
    );
    const selectDiscountList = createSelector(
        (state: any) => state.Discount,
        (discount) => ({
            discountList: discount.discountList
        })
    );
    const homeLayout = useSelector((state: any) => state.HomeLayout.homeLayout);
    const badge = useSelector((state: any) => state.Badge.badge);
    const {discountList} = useSelector(selectDiscountList);
    const {modelList} = useSelector(selectModelList);
    const {colorsList} = useSelector(selectColorsList);
    const {categoryList} = useSelector(selectCategoryList);
    const {brandList} = useSelector(selectBrandList);
    const {attributeList} = useSelector(selectAttributeList);


    useEffect(() => {
        console.log("sss")
        dispatch(onGetBadge());
        dispatch(onGetCategoryList());
        dispatch(onGetAttributeList());
        dispatch(onGetBrandList());
        dispatch(onGetColorsList());
        dispatch(onGetModelList());
        dispatch(onGetDiscountList());
        dispatch(onGetHomeLayout());

    }, [dispatch]);

    console.log(badge)

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Add Product" pageTitle="Product"/>
                    <ProductInformation data={{
                        categoryList,
                        brandList,
                        colorsList,
                        attributeList,
                        modelList,
                        discountList,
                        homeLayout,
                        badge
                    }}/>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default CreateProduct;